import {styled, theme} from 'quickstart/theme/linaria'
import {withTheme} from 'quickstart/theme'

export const FoundIn = withTheme(styled.span`
  padding-right: ${theme.space.xs};
`)
